// DishThumb (v5.14.8) — a small square dish thumbnail used in the meal-pass
// dish pickers and the catering item selection. Falls back to a plate glyph
// when the meal item has no image.
import React from 'react';

export default function DishThumb({ url, size = 'h-11 w-11' }) {
  return url ? (
    <img src={url} alt="" loading="lazy"
      className={`${size} rounded-lg object-cover shrink-0 bg-slate-100`} />
  ) : (
    <div className={`${size} rounded-lg bg-slate-100 flex items-center justify-center shrink-0 text-base`}>🍽️</div>
  );
}
